import Router from '../utils/router.js';
import Loader from './modules/loader.js';
import SearchView from './views/search-view.js';

export default class FAD {
    constructor(el) {
        this.router = new Router();
        this.el = el;
        this.loader = new Loader(this, this.router);
        this.search = new SearchView(this, this.router);
        this.setup();
    }

    setup() {
        this.router
            .add('search', () => {
                this.loader.hide();
                this.search.show();
            })
            .else(() => {
                this.router.update('search');
            })
            .match();
    }
}
